import { useEffect } from 'react';

const useOnDidMount = onDidMount => useEffect(onDidMount, []);

export default useOnDidMount;
